import { mapActions, mapGetters } from "vuex";

// Constants
import STATE from "Constants/campaign/civicactioncenter/state";

// Helpers
import VueValidatorHelper from "JS/helpers/vueValidator";
import ValidationHelper from "JS/helpers/civicactioncenter/validation";

const validationErrorMsgContext = `${STATE.SCOPE_CAC}/${
  STATE.VALIDATION_ERROR_MSG
}`;

export default {
    inject: {
        formHelper: { from: "formHelper" },
        $validator: { from: "$validator" }
    },
    computed: {
    ...mapGetters({
        validationErrorMsg: validationErrorMsgContext
    })
    },
    created() {
    this.validatorHelper = new VueValidatorHelper(this.formFields);
    this.validatorHelper.setValidator(this.$validator);
    },
    methods: {
    ...mapActions({
        setValidationErrorMsg: validationErrorMsgContext
    }),
    async blurField(field, $event) {
        await this.handleFormFieldValue(field, $event.target.value);
    },
    async checkedField(field, value, $event) {
        const fieldValues = this.formHelper.updateCheckboxValue(field, value, $event.target.checked);
        this.handleFormFieldValue(field, fieldValues);
    },
    async handleFormFieldValue(field, value) {
        this.setValidationErrorMsg({});
        await ValidationHelper.handleFormFieldValue(this, field, value);
    }
    }
  };
  